"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intl = require("@kyruus/intl");
var _styles = require("./styles");
const InfoLine = _ref => {
  let {
    Icon,
    iconSize,
    infoMessage,
    values,
    afterText
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.InfoLineContainer, null, /*#__PURE__*/_react.default.createElement(Icon, {
    size: iconSize
  }), /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, infoMessage, {
    values: values
  }), message => /*#__PURE__*/_react.default.createElement(_styles.InfoText, null, message, afterText)));
};
InfoLine.propTypes = {
  /**
   * A JSX component from @kyruus/react-ikons
   */
  Icon: _propTypes.default.func.isRequired,
  /**
   * The size prop to pass the the Icon component
   */
  iconSize: _propTypes.default.string,
  /**
   * The message descriptor to use for the FormattedMessage
   */
  infoMessage: _propTypes.default.shape({
    id: _propTypes.default.string,
    description: _propTypes.default.string,
    defaultMessage: _propTypes.default.string
  }).isRequired,
  /**
   * The values to use for templating the FormattedMessage
   */
  values: _propTypes.default.object,
  /**
   * String to append after the intl message
   */
  afterText: _propTypes.default.string
};
InfoLine.defaultProps = {
  iconSize: '20px',
  values: {},
  afterText: ''
};
var _default = exports.default = InfoLine;
InfoLine.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InfoLine",
  "props": {
    "iconSize": {
      "defaultValue": {
        "value": "'20px'",
        "computed": false
      },
      "description": "The size prop to pass the the Icon component",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "values": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "The values to use for templating the FormattedMessage",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "afterText": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "String to append after the intl message",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "Icon": {
      "description": "A JSX component from @kyruus/react-ikons",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "infoMessage": {
      "description": "The message descriptor to use for the FormattedMessage",
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "string",
            "required": false
          },
          "description": {
            "name": "string",
            "required": false
          },
          "defaultMessage": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    }
  }
};